module.exports = __webpack_public_path__ + "media/images/line-trip-e6c7e0e4e35cc99465ea312320278293.png";